import newYear from './newYear/zh-hk'
import activity from './activity/zh-hk'
export default {
  share: {
    title: '連接·生活',
    open: '打開',
    wxGuide: {
      ios: '請點擊右上角的“…”按鈕，選擇“在Safari中開啟”',
      android: '請點擊右上角的“…”按鈕，選擇“在瀏覽器中開啟”'
    }
  },
  xingshan: {
    home: {
      title: '中移動香港行山節',
      bg: 'static/xingshan/xingshan-bg-tc.jpg',
      subTitle: '全港動起來 向健康出發 為健康 一齊行',
      actTime: '活動日期：',
      noon: '（中午12時）',
      status: ['現正接受報名', '留意抽籤結果', '查看抽籤結果（抽籤結果公佈）', '確認報名', '期待活動', '進行中', '萬步有禮活動進行中..'],
      process: ['報名日期', '截止報名', '抽籤結果公佈', '報名確認期', '活動日'],
      actDetail: '活動詳情',
      invite: '邀請你參加中移動香港行山節',
      inviteConfirm: '12.16行山節活動報名查詢',
      detail1: '「中移動香港行山節」由中國移動香港和中國香港旅行遠足聯會聯合主辦，目的是推動全港市民參與，提高市民步行及行山的健康意識，為健康，一齊行。',
      detail2: '大會舉辦行山節，旨在推廣香港行山路徑及郊野公園，如是次活動選址的山頂環迴步行徑和薄扶林水塘家樂徑；而鳳凰徑、麥理浩徑、衞奕信徑等亦是香港著名的行山徑。大會期望鼓勵市民一齊行，攜手發掘香港郊野公園的特色，推而廣之成為香港旅遊的重點。',
      detail3: '「中移動香港行山節」除了在12月16日當天舉行行山活動外，更鼓勵當日未能出席的市民在全港一同參與。大會鼓勵市民當天以步行10000步為基礎，完成萬人行萬步的創舉，並培養每天步行的習慣。',
      route: {
        title: '行山路徑',
        startPoint: '起點：山頂環回步行徑',
        routeList: [{
          name: '家庭樂組：山頂環迴步行徑（山頂廣場⇨夏力道⇨盧吉道）',
          timeLabel: '行程：',
          time: '約1小時10分',
          lengthLabel: '長度：',
          length: '約3.5公里',
          linkLabel: '詳情 >',
          link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=山頂廣場-夏力道-盧吉道&lang=tc&/#/xingshan/route/0'
        }, {
          name: '公開組：山頂廣場⇨夏力道⇨薄扶林家樂徑⇨薄扶林水塘道',
          timeLabel: '行程：',
          time: '約2小時',
          lengthLabel: '長度：',
          length: '約5.7公里',
          linkLabel: '詳情 >',
          link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=山頂廣場-夏力道-薄扶林家樂徑-薄扶林水塘道&lang=tc&/#/xingshan/route/1'
        }]
      },
      traffic: '交通',
      trafficList: ['從中環天星碼頭乘搭15C號巴士，或在港鐵中環站 J2出口步行至花園道山頂纜車站，再搭乘山頂纜車登山。', '從港鐵香港站D出口往中環交易廣場巴士總站，乘搭15號巴士。', '從港鐵香港站E出口往公共運輸交匯處，乘搭1號綠色小巴。'],
      food: {
        title: '景點美食',
        list: [
          {
            title: '香港杜莎夫人蠟像館',
            img: ['static/xingshan/img/Madame Tussauds 1_l.png','static/xingshan/img/Madame Tussauds 2_l.png'],
            content: ['位於山頂凌霄閣的香港杜莎夫人蠟像館，自2000年開幕以來，一直是香港最受歡迎的旅遊景點之一，館內集合超過100個按真人比例打造的名人蠟像，栩栩如生，他們分別展覽於多個展區，包括「草間彌生藝術館」、「功夫專區」、「韓流專區」、「樂壇巨星」、「時尚專區」、「風雲人物」、「世界首影」、「魅力香江」、「體壇猛將」及「動漫遊戲世界」。館內不設圍欄，讓您盡情與心愛偶像或風雲人物零距離接觸及拍照留念。參觀展區後，您更可到精品廊選購小金人獎座、限定版公仔及3D立體照等精緻紀念品留念。']
          },
          {
            title: '太平山餐廳',
            img: ['static/xingshan/img/The Peak Lookout 1_l.png','static/xingshan/img/The Peak Lookout 2_l.png'],
            content: ['太平山餐廳座落於景色優美的太平山頂地段，原名山頂餐廳，為全亞洲最歷史悠久的建築物之一，亦被列為香港二級歷史建築。19世紀末，該建築原為興建山頂纜車的英國工程師提供工作和休憩的地方，及後於1947年改建為餐廳。太平山餐廳的屋頂用紅磗建成，因而有「紅磚屋」的稱號。餐廳提供各種品質卓越的國際佳餚美饌，裝潢「中西合壁」，以老上海為主題，融入歐式鄉村典雅，更設有露天花園，讓客人在戶外用餐時，可鳥瞰南中國海和薄扶林郊野公園的醉人景色。']
          },
          {
            title: '山頂纜車及山頂纜車歷史珍藏館',
            img: ['static/xingshan/img/Peak Tram_l.png'],
            content: ['山頂纜車於1888年啟用，起初只為居住在太平山頂上的香港總督及富商提供服務，現已成為一項深受旅客歡迎的觀光交通工具。山頂纜車的路軌全長1.4公里，復古外型的車廂幾乎45度傾斜著攀升，一列纜車由兩個車卡組成，兩列纜車能夠同時以相反方向行駛，每小時可以載客2,800人次，來往中環花園道及山頂兩座總站的車程約7分鐘。',
              '乘客可憑纜車票免費參觀山頂纜車歷史珍藏館，認識這條逾百年歷史的亞洲第一條纜索鐵路的點滴。館內設有15個主題展區，展出超過200件來自世界各地與纜車相關的豐富珍藏，此外還展出了一卡仿製第一代山頂纜車供遊人參觀和拍照。您更可在館內了解纜車動力系統的設計和歷史發展，細賞昔日山頂纜車售票員的制服、響鈴車票打孔機售票系統和車票，以及風靡男女老少遊客的纜車和火車收藏品。']
          },
          {
            title: '凌霄閣摩天台428',
            img: ['static/xingshan/img/The Peak Tower_l.png'],
            content: ['凌霄閣摩天台428位於海拔428米的山頂凌宵閣上，因而得名。不論日間或晚上到訪這個360度全方位開放式的無敵觀景台，皆可居高臨下感受香港城市和大自然共融的獨特面貌。',
              '摩天台的一邊可俯瞰維多利亞港兩岸的迷人景致，將中銀大厦、國際金融中心、香港會議展覽中心、環球貿易廣場等著名香港地標盡收眼底；另一邊則可眺望長洲、大嶼山和南丫島等離島的醉人景色。您更可利用場內的免費Wi-Fi啟動「香港摩天導覽」語音互動導覽服務，以生動的方式認識香港的歷史、文化、建築和生活故事。']
          },
          {
            title: '伯大尼修院內之小教堂',
            img: ['static/xingshan/img/Bethanie_Church_2_l.png'],
            content: ['伯大尼修院位於香港薄扶林道139號，於1875年落成，現為香港一級法定古蹟。修院成立之初，是巴黎外方傳教會在東亞地區的首間療養院（入口鐵門上面的「ME」字樣正是巴黎外方傳教會的縮寫），其後由政府接管，於1978至1997年期間曾租予香港大學使用，現為香港演藝學院古蹟校園。',
              '伯大尼修院內的小教堂是香港唯一一座新哥德式教堂，沿用拱形圓頂及飛扶壁設計，彩繪玻璃、12門徒的聖像及各種陳設，都帶着19世紀法國傳教士對信仰、感召和奉獻的動人故事。小教堂所用的地磚亦是獨一無二，相信是從法國進口。小教堂可容納約150人，逢星期日及其他聖日舉行禮拜，平日開放租予公眾人士舉行婚禮。']
          },
          {
            title: '伯大尼修院內之惠康劇院  - 牛奶公司牧場遺址',
            img: ['static/xingshan/img/Bethanie_Church_1_l.png'],
            content: ['香港政府於2003年將伯大尼修院和隔壁的牛奶公司牛棚批予香港演藝學院改建為校舍。在牛奶公司贊助下，香港演藝學院將鄰近伯大尼修院的兩座八角形牛棚，改建成小展覽廳及惠康劇院，並於2007年3月改建完工，劇院適合各類表演、會議、電影放映、室樂演奏、實驗演出等活動及小型演出。 ',
              '劇院現時仍保留原有的八角形屋頂和其中一座牛棚，讓訪客感受當年的牧牛情況。而昔日的牛奶公司牧場在1983年已關閉，留下牧場遺址。 2008年，伯大尼修院獲聯合國教科文組織頒發亞太區文物古蹟保護獎的榮譽獎，以表揚其復修工程。']
          },
          {
            title: '薄扶林村',
            img: [],
            content: ['薄扶林村位於香港島南區，歷史可追溯至17世紀，因而有「未有香港，便先有薄扶林村」的說法。全村分為「圍仔」、「菜園」和「龍仔督」三個主要部分，房屋以磚屋及鐵皮屋為主。港島的村落不少，但只有薄扶林村受到學者的重視，原因是目前只有在薄扶林村才能找到原居民的後裔聚居。',
              '2013年，薄扶林村成為首個登上「世界歷史遺跡監察名單」的香港歷史遺跡。有形遺產包括傳統村莊房子和設置、李靈仙姐塔、牛屎湖；無形的遺產包括李靈仙姐誕和薄扶林村舞火龍等。2017年，薄扶林村舞火龍更獲列入「香港非物質文化遺產清單」。沿著舞火龍活動的路線，便可參觀薄扶林村各座主要歷史建築。']
          },
          {
            title: '中華廚藝學院中菜館',
            img: [],
            content: ['位於薄扶林的中華廚藝學院，是職業訓練局旗下提供中菜烹調課程的專門學院，以宏揚中華飲食文化為使命。學院設有食品科學實驗室、訓練廚房、出品廚房、訓練餐廳和酒廊等設施，讓學員在真實的工作環境下學習。作為學院中式訓練餐廳的中菜館，位於綜合大樓7樓，由迎賓、烹調到上菜，客人都可以感受到學院訓練的嚴謹，以及學員對中華廚藝的熱誠。']
          },
          {
            title: '珍寶海鮮舫',
            img: ['static/xingshan/img/Jumbo Seafood Restaurant_l.png'],
            content: ['珍寶海鮮舫於1976年建成開業，是停泊於香港島南區香港仔深灣的水上餐廳。珍寶海鮮舫樓高三層，面積達45,000平方呎，可容納逾2,300名賓客，因此有「世界上最大的海上食府」之稱，是外國遊客必到之地，至今累積遊客人次超過3,000萬。在傳統中國宮殿裝修的餐廳內，客人可享用各式海鮮美饌、傳統及新派美食，不少中外政要、商界名人和國際巨星都曾是座上客。珍寶海鮮舫也是許多著名電影，例如《生死戀》、《龍爭虎鬥》、《無間道2》以及《食神》的取景場地。夜間的珍寶海鮮舫五光十色，名副其實是香港的海上明珠。']
          }
        ]
      },
      rules: {
        title: '萬步有禮  送出100部智能手機',
        list: [
          '為了鼓勵全港市民響應「為健康 一齊行」，於12月16日當日，除了《中移動香港行山節》啟動禮外，將同時舉辦一個「萬步有禮」活動，目標是吸引全港市民一同創出「億步行」的壯舉。',
          '認識香港，從你的眼中開始！香港24個郊野公園各有獨特的美麗景觀，跟香港繁忙燦爛的都市景緻相映成趣，從不同角度均散發魅力。因此，在活動當日（12月16日- 00:00-23:59），所有參加者只需登入MyLink App，無論行山、行街、或行去任何地方，以MyLink App計步器錄得10,000步後，即獎你中銀集團保險「保險計劃優惠包」優惠碼，如屬中國移動香港客户更可獲得$20元電子繳費券或增值券。同時上載「最能代表香港的相片」一張到WeWalk「萬步有禮」活動內，更有機會獲得智能手機一部。',
          '參加相片將由專業評審團選出150名進入公眾投票階段，最高票數之100名將有機會獲贈智能手機乙部，而其餘50名入圍者亦有機會獲贈行山節精美揹包乙個。100名得獎作品更將會被製作成為手機Wallpaper，免費供公眾下載。',
          '大會期望透過是次活動，鼓勵全港動起來、向健康出發，落實「為健康 一齊行」，同時讓更多香港人欣賞這個美麗城市的郊野風光及都市景緻，為香港大都會發掘更多魅力。'
        ],
        time: {
          title: '活動時間表',
          list: [
            '活動日期: 2018年12月16日',
            '活動時間: 00:00 - 23:59',
            '作品甄選: 2018年12月17日至12月24日',
            '公眾投票: 2018年12月24日凌晨00:00至12月30日晚上23:59',
            '投票渠道: MyLink 手機應用程式',
            '公佈得獎日期 : 2019年1月7日中午12時',
            '公佈渠道: MyLink 手機應用程式'
          ]
        },
        join: {
          title: '參加方法',
          list: [
            '下載MyLink 手機應用程式',
            '開啟「生活」內WeWalk頁面',
            '當天必須行滿1萬步後，計步器將會發出提示',
            '當日拍攝一張香港照片連同標題 (相片檔案限制：不超過5MB) 上載至WeWalk'
          ]
        },
        reward: {
          title: '獎品',
          list: [
            '參加者只要成功行滿1萬步後，即可獲得中銀集團保險「保險計劃優惠包」優惠碼，如屬中國移動香港客户更可獲得電子繳費劵或增值券（價值$20）。',
            '參加相片將由專業評審團選出150名進入公眾投票階段，公眾投票最高票數之100名將獲贈智能手機乙部，其餘50名入圍者可獲贈行山節精美揹包乙個。詳情如下：'
          ],
          table: [
            {
              label: '票數排名第一至第五名',
              value: 'iPhone XS (256GB)'
            },
            {
              label: '票數排名第六至第十名',
              value: 'Samsung Galaxy S9+ (256GB)'
            },
            {
              label: '票數排名第十一至第二十五名',
              value: 'iPhone 8 (256GB)'
            },
            {
              label: '票數排名第二十六至第三十名',
              value: 'HUAWEI Mate 20 Pro'
            },
            {
              label: '票數排名第三十一至第五十五名',
              value: 'HUAWEI P20'
            },
            {
              label: '票數排名第五十六至第八十名',
              value: 'Samsung Galaxy A8+'
            },
            {
              label: '票數排名第八十一至第一百名',
              value: 'iPhone SE (128GB)'
            },
            {
              label: '票數排名第一百零一名至第一百五十名',
              value: '「中移動香港行山節」指定背囊'
            }
          ]
        },
        ruleL: '有關活動之條款及細則，請',
        ruleR: '按此',
        ruleRR: '',
        article: '活動簡介：',
        info: '不論你是否中國移動香港的客户，都可於活動期間2018年12月16日10:00至17:00登入MyLink App，進入「MyLink 萬步有禮」專頁，按「開始活動」開啟計步功能，並在計步期間內一直開啟MyLink App。當你的步數達到10000步時，可獲得換領禮品的機會一次。',
        linkText: '查閲【MyLink 萬步有禮】活動詳情及細則'
      },
      prize: {
        title: '當參加者達成以下得獎規則所訂下之目標，即有資格獲得以下獎項及禮品：',
        prizeA: '全城有獎',
        prizeAList: [
          '規則：凡於活動期間用MyLink計步器計步步數達5000步，即有資格獲取以下禮品。禮品數量沒有限制：',
          '1GB 4.5G本地數據用量',
          '$20電子繳費券',
          '$20電子增值券',
          '中銀集團保險「環宇遨翔旅遊保障計劃」優惠碼68折'
        ]
      },
      submit: '立即報名',
      submitConfirm: '抽籤結果查詢',
      submitSign: '簽到',
      submitWalk: '參與活動',
      submitConfirmed: '參加12.16「萬步有禮」活動'
    },
    walk: {
      title: 'MyLink 10000步有禮',
      bg: 'static/xingshan/1w-bg-tc.jpg',
      startLabel: '開始時間',
      startTime: '早上10:00',
      endLabel: '結束時間',
      endTime: '下午5:00',
      actTime: '活動日期：',
      invite: '邀請你參加MyLink 10000步有禮',
      desc: '每天運動其實不難，今天就由10000步開始，踏出健康生活第一步，為健康，一齊行。「中移動香港行山節」除了在12月16日會在山頂公園舉行開步禮外，更鼓勵當日所有市民，在全港任何一個角落進行步行運動，在指定的時間內，步數達到10000步或以上，更可獲得豐富獎品，全城有獎！',
      actDetail: '活動簡介',
      detail: '不論你是否中國移動香港的客户，都可於活動期間2018年12月16日10:00至17:00登入MyLink App，進入「MyLink 10000步有禮」專頁，按「開始活動」開啟計步功能，並在計步期間內一直開啟MyLink App。當你的步數達到10000步時，可獲得換領禮品的機會一次。',
      detail1: '1. 正式開始活動前，一定要有下載最新版本的 MyLink App。你可以到以下的App Store或 Google Play的連結下載。',
      detail2: '2. 活動期間2018年12月16日10:00至17:00登入 MyLink，進入「生活」>「一齊行」頁面，進入「MyLink 10000步有禮」專頁。',
      detail3: '3. 按「開始活動」開啟計步功能，並在計步期間內一直開啟MyLink App。',
      detail4: '4. 當你的步數達到10000步時，系統會自動紀錄換領獎品的機會。',
      prize: {
        title: '獎項及禮品介紹',
        text1: '每位合資格用户最多可獲兩份禮品，包括中銀集團保險「保險計劃優惠包」優惠碼、中國移動香港的電子券（價值$20）等。',
        text2: '10000步到底有幾多？',
        text3: '若果以一個身高1.7米的人來計算，平均10米大約走16步，1公里就大約1600步了。10000步，就是約6公里了，也就是由山頂廣場到薄扶林的步行距離了。',
        text4: '平均來説，香港人普遍一日走的步數約在6000-8000步之間，上世紀60年代，開始有研究建議，如果每日走10000步，再配合適當的步速及維持中度的心跳速度的話，長期有助改善心臟及血管健康。',
        text5: 'MyLink App中的計步器功能，可以準確地量度步行時手持手機的搖擺幅度，從而計算出步數，更可跟朋友分享你的運動成果。只需每天登入MyLink，保持連線狀態，就可容易方便地紀錄你的步數和卡路里消耗。你今日又走了幾多步？'
      }
    },
    inter: {
      title: '中移動香港行山節',
      title1: '中移動香港行山節',
      bg: 'static/xingshan/inter-bg-tc.png',
      subTitle: '全港動起來 向健康出發 為健康 一齊行',
      invite: '邀請你參加中移動香港行山節',
      desc: '「中移動香港行山節」由中國移動香港和中國香港旅行遠足聯會聯合主辦，目的是推動全港市民參與，提高市民步行及行山的健康意識，為健康，一齊行，同時希望將「遠足」打造成為「香港名片」由香港出發，面向國際宣傳香港是遠足活動的首選熱點。',
      desc1: '大會舉辦行山節，旨在推廣香港行山路徑及郊野公園，如是次活動選址的山頂環迴步行徑和薄扶林水塘家樂徑；而鳳凰徑、麥理浩徑、衞奕信徑等亦是香港著名的行山徑。大會期望鼓勵市民一齊行，攜手發掘香港郊野公園的特色，推而廣之成為香港旅遊的重點。',
      back: '進入「第二屆中移動香港行山節」',
      url1: 'https://www.wewalk.hk/2018/12/17/%e4%b8%ad%e7%a7%bb%e5%8b%95%e9%a6%99%e6%b8%af%e8%a1%8c%e5%b1%b1%e7%af%80/',
      url3: 'https://mylink.komect.com/activity/via/mountainreview/index.html?lang=tc',
      back1: '進入「第一屆中移動香港行山節」',
      back3: '進入「第三屆中移動香港行山節」',
      back4: '進入「第四屆中移動香港行山節」',
      back5: '進入「第五屆中移動香港行山節」',
      uaturl4: 'https://uatoss.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/four?lang=tc',
      uaturl5: 'https://uatoss.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/five?lang=tc',
      paturl4:'https://cdn.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/four?lang=tc',
      paturl5:'https://cdn.mylinkapp.hk/via/atv/new-mountainreview-fe/index.html#/five?lang=tc',
    },
    login: {
      title: '活動登記',
      phone: '手機號',
      mobilePlaceholder: '請輸入手機號',
      codePlaceholder: '請輸入驗證碼',
      sendCode: '獲取驗證碼',
      submit: '提交',
      tip: {
        mobileEmpty: '請輸入手機號',
        mobileError: '請輸入正確的手機號碼',
        codeEmpty: '請輸入驗證碼',
        codeFail: '獲取驗證碼失敗',
        codeError: '請輸入正確的驗證碼',
        codeExpired: '驗證碼已過期，請再取新一個驗證碼',
        checkFail: '系統繁忙, 請稍後再試！'
      }
    },
    sign: {
      title: '活動登記',
      nameLabel: '姓名',
      lastName: '姓',
      firstName: '名',
      emailLabel: '電郵',
      emailPlaceholder: '請輸入電郵地址',
      routeLabel: '參加路線',
      extraPersonLabel: '是否攜帶其他人員參加',
      yes: '是',
      no: '否',
      submit: '提交',
      personNumList: [{ key: 1, value: '1 人' }, { key: 2, value: '2 人' }, { key: 3, value: '3 人' }],
      rules1: '本人聲明本人已年滿18歲(年齡以活動當日計算)。本人及同行參加者細閱並同意本活動之',
      rules1_1: '及',
      rules1_2: '。主辦機構保留取消不接受上述條款之參加者的參加資格。',
      rules2: '本人同意接收中國移動香港有限公司提供的最新資訊',
      rulesLinkText: '「參加者須知及條款細則」',
      rulesLinkText1: '「免責聲明」',
      rulesLinkText2: '「個人資料收集聲明」',
      rulesLink1: '/xingshan/sign/privacy',
      rulesLink2: '/xingshan/sign/personal',
      tip: {
        nameEmpty: '請輸入正確姓名',
        errorEmail: '請輸入正確電郵格式',
        existEmail: '該電郵已被使用',
        routeEmpty: '請選擇參與線路',
        personEmpty: '請選擇攜帶人數'
      },
      dialog: {
        title: '活動登記信息如下',
        nameLabel: '姓名：',
        phoneLabel: '電話：',
        emailLabel: '電郵：',
        routeLabel: '已選擇路線：',
        extraLabel: '額外參與人數：',
        yes: '提交',
        no: '取消',
        personUnit: '人'
      },
      rules: {
        title: '參加者須知及條款細則',
        infor: '「中移動香港行山節」 - 山頂行山活動條款及細則',
        dt1: '參加者須知及條款細則',
        list1: [
          '「中移動香港行山節」由中國移動香港有限公司(「中國移動香港」)及中國香港旅行遠足聯會(「旅聯」) 聯合主辦。',
          '在下列的條款及細則內「活動」乃指2018年12月16日舉行的「中移動香港行山節」山頂行山活動；「參加者」為參與是次活動的人士；「主辦機構」為中國移動香港及旅聯；「路線」是由主辦機構指定的行山路線。',
          '參與活動確認一經遞交，即代表參加者及額外同行參加者確認及同意接受一切主辦機構不時所定之活動的規則、條款和安排。',
          '18歲以下參加者必須於[2018年12月10日]或之前以電郵(wewalk.enquiry@gmail.com)方式向主辦機構提交已簽署之家長/監護人同意書。主辦機構保留取消於限期前未能提交同意書之18歲以下參加者的參加資格。'
        ],
        dt2: '活動細節',
        list2: [
          '活動設有家庭樂組及公開組。家庭樂組沒有年齡限制，但家庭樂組組長必須於活動當日年滿18歲。公開組參加者必須於活動當日年滿12歲。每名16歲以下之參加者必須由18歲或以上的成年人陪同參加。 18歲以下的參加者必須事先獲家長或監護人簽署同意書方可參加。主辦機構保留在活動前後或進行期間，核實參加者年齡及(如有需要)該等同意書證明的權利。',
          '主辦機構在得悉或懷疑情況下，保留、限制拒絕接受報名或取消任何不適宜參加本活動的參加權利，包括但不限於如申請者提供錯誤資料、不能提交報名表、不依從正確報名程序報名、或身體狀況不適宜參加本活動(如懷有身孕、患慢性疾病如心臟病及高血壓人士)。',
          '參加者必須最遲於活動當天上午1​​1時30分抵達山頂廣場對出空地，逾時者會被取消參加資格。若參加者未能按照其指定參加組別及時間起步，或未能依循所報名的路線完成活動，主辦機構有權取消其參加資格，有關參加者將不會獲發紀念獎牌及證書。',
          '參加者不可攜帶或使用任何滾軸鞋、滑板、手推車或其他大型物件，亦不可攜同任何動物參與。',
          '參加者於活動前後及進行期間，必須遵照主辦機構、授權人員以及其他工作人員包括警察、民眾安全服務隊、醫療輔助隊、食物環境衞生署及康樂及文化事務署的所有合法指示。',
          '參加者請於活動期間保持專業及禮貌的態度。',
          '步畢家庭樂組路線全程約需1小時；步畢公開組路線全程約需2小時。沿途部分地區並無遮蓋，參加者需確保體力適宜才參與，如有疑問，應先向醫生查詢。如未能步畢全程，可於中途退出，部分退出點有公共交通工具接駁。活動實際完結時間以主辦機構及授權人員所安排的押尾小隊決定為準。',
          '參加者需穿上合適的衣服及鞋襪，並自備充足飲品、食物、帽及雨具等。',
          '是次行山活動途徑車路及泥路小徑，參加者須特別小心。請勿奔跑、爭先恐後、倚靠或攀爬沿途任何物件，以確保安全。',
          '參加者需自行承擔一切責任。主辦機構及授權機構並不會對參加者於活動當天因任何事情或理由所引致的任何個人傷亡或財物損失承擔任何責任。',
          '主辦機構保留更改條款細則、路線等安排的權利。',
          '主辦機構若認為參加者沒有完全遵照或違反本條款及細則的規定，主辦機構有權取消參加者的資格或於行山活動中任何時間內終止參加者繼續參加。主辦機構的判決為最終及不可推翻的決定。'
        ],
        dt3: '惡劣天氣',
        list3: [
          '如天文台於活動當日早上六時或之後懸掛黑色暴雨、紅色暴雨、雷暴或三號颱風警告，活動將會取消，主辦機構將另擇日子舉行活動。',
          '如活動進行中天氣惡劣或懸掛任何天氣警告，又或主辦機構評估後判斷當天並不適合舉行活動，主辦機構有權將活動路徑改變或取消正在進行中的活動。主辦機構不會另擇日子補辦活動。',
          '如是次活動因天氣惡劣或懸掛任何天氣警告或其他原因而取消，主辦機構將另行通知活動補辦日期。',
          '主辦機構強烈要求參加者於活動舉行當天早上致電香港天文台查詢天氣情況。 (電話：1878200)'
        ],
        dt4: '其他事宜',
        list4: [
          '主辦機構不會提供行李寄存。切勿攜帶貴重物品，如有損毀或遺失，主辦機構將不會負任何責任及作出任何賠償。',
          '參加者如活動過程中須向主辦機構查詢及要求協助，請沿途與就近工作人員聯絡。',
          '所有由主辦機構提供的活動包、禮品及任何其他物品(「禮品」)不可兑換現金，亦不能更換、退款、轉讓及轉售。本活動所有的禮品視乎供應情況而定，換領完即止。每名參加者只可領取一份活動包，不可代他人領取。如任何因禮品所引起的爭議，主辦機構概不負責。',
          '主辦機構對供應商提供的商品或服務之品質、安全性及合法性，刊登內容之真實性及準確性，供應商的商譽與可信性均無控制力及保證。',
          '參加者需自行負責個人意外保險。',
          '主辦機構保留使用活動當天所拍得照片或錄像的權利，包括商業宣傳用途。',
          '主辦機構保留本活動的最終決定權。活動不設上訴機制。主辦機構擁有修改及解釋本條款規則的權利，任何有關活動的臨時改動或取消，將以主辦機構公佈為準。',
          '本條款及細則受香港法律管轄。參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
          '本條款與細則的中、英文本如有任何歧義，概以英文本為準。',
          '如有任何爭議，主辦機構將保留一切最終決定權。'
        ],
        r9: '參加者不可攜帶或使用任何滾軸鞋、滑板、手推車或其他大型物件，亦不可攜同任何動物參與。',
        r10: '電話：2127 4720 (星期一至五早上10時至晚上7時)',
        r11: '電郵：wewalk.enquiry@gmail.com',
        r12: '大會擁有修改及解釋以上規則的權利。'
      },
      personal: {
        title: '個人資料收集聲明',
        list: [
          '主辦機構將會在參加者確認出席「中移動香港行山節」山頂行山活動時，收集參加者的個人資料，包括姓名、手提電話號碼等。主辦機構保障參加者所提供之一切資料。當參加者提交確認時，有關個人資料將會被收集、儲存及使用以作核實。',
          '本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知您作為參加者收集資料的目的、您同意主辦機構如何使用這些資料及您的權利。本聲明會不時更改，故請定期查閲。參加者每次登記及/ 或使用我們的服務時，即表示同意接受當時生效之個人資料收集聲明。',
          '參加者可能會被要求向主辦機構提供個人識別資料。為讓參加者可以參加「中移動香港行山節」山頂行山活動，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得參賽資格。'
        ],
        dt1: '資料之目的及用途',
        list1: [
          {
            title: '主辦機構所收集之資料將用作以下用途：',
            list: [
              '識別和核實參加活動的參加者的身份及/ 或資格',
              '就有關或因參加活動的事項與參加者或其緊急聯繫人溝通',
              '彙編參加者的整體統計資料，分析、評估及改進主辦機構所提供的活動'
            ]
          }
        ],
        dt2: '資料之轉移',
        list2: [
          '參加者之個人資料將被保密。然而由於系統管理、運作及保養需要，主辦機構會將有關資料轉移或披露予對主辦機構有保密責任並提供與主辦機構運作有關行政、電訊、電腦系統服務、數據處理或其他服務的承辦商。',
          '參加者有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閲或更正參加者之個人資料。如有任何查閲或更正資料的要求，請向本公司資料保障主任提出，其辦事處位於香港新界葵涌葵昌路51號九龍貿易中心1座20樓。主辦機構的私隱政策聲明可於其網頁www.hk.chinamobile.com獲取。'
        ]
      },
      privacy: {
        title: '免責聲明',
        info: '謹此聲明本人參加本活動，並願意遵守由主辦機構所訂的條文及規則，以及同意以下所列各點：',
        list: [
          '本人是自願參加此活動和願意承擔自身的意外風險及責任，並無權向主辦機構對本人往返活動場地途中、活動中發生或引致之自身意外、死亡或任何形式的損失提出索償或追討責任。',
          '本人聲明本人身體情況良好及有能力參加此活動，及沒有執業醫生曾提出相反意見。',
          '本人願意接受主辦機構要求及提供的藥物檢查及治療。',
          '本人於活動當天（2018年12月16日）已經符合參加組別之最低年齡規定（如參加者未年滿18歲，須由其家長或監護人簽署同意聲明）。',
          '本人明白及同意本人的個人資料將轉交予主辦機構用作活動安排之用途。',
          '本人證實已事先獲得同行參加者及/或緊急聯繫人的同意，可使用其個人資料於本活動的報名表格作報名及/或緊急聯繫用途。',
          '本人願意授權予及同意主辦機構及傳媒在不需要審查情況及不需要本人另外同意下而可使用本人的個人資料、肖像、姓名及聲線作為籌辦及推廣活動之用，包括本人肖像及姓名有可能被使用於主辦機構有關本活動之網頁、短片及刊物。',
          '本人提交確認即表示同意及確認所有列明之「參加者須知及條款細則」、「免責聲明」及「個人資料收集聲明」，以及所有不時於活動指定宣傳渠道更新的任何更改。'
        ]
      }
    },
    error: {
      title: '系統繁忙',
      info: '活動登記失敗，請返回再試'
    },
    result: {
      title: '登記結果',
      registered: {
        title: '登記查詢',
        article: '已登記',
        info: '閣下已登記參與12月16日「中移動香港行山節」，為健康，一齊行！',
        info1: '大會將以抽籤形式抽出當日出席開步禮的參加者，並於12月1號以短訊通知結果。敬情留意！',
        info2: '',
        tip: '您可同時參與12月16日舉辦的《MyLink 萬步有禮》，在指定的時間內，步數達到萬步或以上，即有資格贏得豐富獎品，全城有獎！',
        registeredLabel: '活動登記信息如下：',
        nameLabel: '姓名：',
        phoneLabel: '電話：',
        emailLabel: '電郵：',
        routeLabel: '參加路線：',
        extraLabel: '額外參與人數：',
        link: '查閲【MyLink 萬步有禮】活動詳情及細則',
        personUnit: '人'
      },
      success: {
        title: '登記查詢',
        article: '登記成功',
        info: '閣下已登記參與12月16日「中移動香港行山節」，為健康，一齊行！',
        info1: '大會將以抽籤形式抽出當日出席開步禮的參加者，並於12月1號以短訊通知結果。敬情留意！',
        info2: '',
        tip: '您可同時參與12月16日舉辦的《MyLink 萬步有禮》，在指定的時間內，步數達到萬步或以上，即有資格贏得豐富獎品，全城有獎！',
        link: '查閲【MyLink 萬步有禮】活動詳情及細則'
      },
      confirmed: {
        title: '提交結果',
        article: '成功確認參與！',
        registeredLabel: '活動參與信息如下：',
        nameLabel: '姓名：',
        phoneLabel: '電話：',
        routeLabel: '已選：',
        extraLabel: '額外參加者的資料如下：',
        extraItemLabel: '額外人員',
        ps: '重要訊息：有關12月16日當天的交通及集合安排，大會將以短信方式發送至閣下手機，敬請留意。',
        rules: {
          title: '中移動香港行山節 <br/> 萬步有禮 送出 100 部智能手機',
          list: [
            '為了鼓勵全港市民響應「為健康 一齊行」，於12月16日當日，除了《中移動香港行山節》啟動禮外，將同時舉辦一個「萬步有禮」活動，目標是吸引全港市民一同創出「億步行」的壯舉。',
            '在活動當日（12月16日- 00:00-23:59），所有參加者只需登入MyLink App，無論行山、行街、或行去任何地方，以MyLink App計步器錄得10,000步後，即獎你中銀集團保險「保險計劃優惠包」優惠碼，如屬中國移動香港客戶更可獲得$20元電子繳費券或增值券。同時上載最能代表香港的相片一張到WeWalk「萬步有禮」活動內，更有機會獲得智能手機一部。',
            '參加相片將由專業評審團選出150名進入公眾投票階段，最高票數之100名將有機會獲贈智能手機乙部，而其餘50名入圍者亦有機會獲贈行山節精美背包乙個。100名得獎作品更將會被製作成為手機Wallpaper，免費供公眾下載。'
          ],
          link: '萬步有禮 創紀錄 贏手機 詳情'
        }
      },
      noregistered: {
        title: '提交結果',
        article: '抱歉！',
        info: '系統未能找到您的登記資料。',
      },
      nowinning: {
        title: '提交結果',
        article: '抱歉！',
        info: '多謝閣下報名參加 「中移動香港行山節」，由於反應熱烈，是次活動名額已滿，再次多謝各位踴躍支持！我們鼓勵閣下當日一同參與「萬步有禮 創紀錄 贏手機」',
      },
      signSuccess: {
        title: '簽到結果',
        article: '閣下已簽到！'
      },
      signed: {
        title: '簽到結果',
        article: '閣下已簽到！'
      },
      needSign: {
        title: '簽到結果',
        article: '抱歉！',
        info: '需要參與活動的隊長掃QRCODE以簽到～'
      },
      sign: {
        title: '簽到結果',
        article: '簽到訊息確認',
        signCheck: '一經簽到後，人數不能改變！'
      },
      signFail: {
        title: '簽到結果',
        article: '未能查詢閣下參與活動訊息，請與工作人員聯絡。'
      }
    },
    loginConfirm: {
      title: '抽籤結果查詢',
      subTitle: '請輸入用於登記本活動之手機號碼'
    },
    signConfirm: {
      title: '活動報名',
      subTitle: '恭喜！您已被抽中參與「中移動香港行山節」，請填寫以下的報名資料以確定報名資格。',
      subTitle1: '請填寫以下報名資料：',
      routeLabel: '參加路線：',
      nameLabel: '緊急聯絡人姓名',
      lastName: '姓',
      firstName: '名',
      phoneLabel: '緊急聯絡人電話',
      phonePlaceholder: '手機號碼',
      extraPersonLabel1: '額外參加者（最多',
      extraPersonLabel2: '人）',
      extraPersonLimit: '3',
      addExtra: '增加額外參加者',
      extraEmCheckbox: '使用和我相同的緊急聯絡人資料',
      extraDifferent: '新增的額外人數與登記活動時人數不同，是否繼續提交？',
      rules1: '大會會於活動當日在金鐘海富中心有免費接駁巴士前往山頂廣場，您和您的隊員會否採用？',
      rules2: '本人聲明上述同行參加者中有18歲以下參加者。本人同意大會將會按本人所提供的電郵地址，以電郵提供家長/監護人同意書。本人明白必須於2018年12月10日或之前以電郵交回已簽署之家長/監護人同意書相關參加者才可參與本活動。主辦機構保留取消於限期前未能提交同意書之18歲以下參加者的參加資格。(18歲以下參加者適用，年齡以活動當日計算)',
      tip: {
        errorPhone: '請輸入正確的手機號碼',
        repeatPhone: '請提供一個不同的額外參加者聯絡電話',
        errorEmergencyPhone: '請輸入正確的緊急聯絡人手機號碼',
        emergencyNameEmpty: '請輸入正確的緊急聯絡人姓名',
        unavailableExtra: '此額外的參加者已報名，您可刪減或增加其他參加者',
        notice: '提示',
        delExtra: '是否刪除此額外人員信息？'
      },
      extraListLabel: {
        title: '額外人員',
        name: '姓名',
        phone: '電話',
      },
      advance: '[萬步有禮] 活動將於12月16日正式舉行'
    },
    transferConfirm: '抽籤結果 密切留意',
    bindPhone: {
      title: '綁定手機號'
    },
    walkNotEnough: {
      title: '萬步有禮',
      info: '距離萬步還差{{step}}步，請繼續努力！完成後有機會贏取智能手機大獎。',
      unit: '步',
      left: '距離萬步還差：',
      countInfo: '總步數',
      submit: '返回首页'
    },
    walkReward: {
      title: '得獎結果',
      ad: {
        title: '[萬步有禮]活動，贏手機',
        info: [
          '大會鼓勵全民運動，特意舉辦「萬步有禮」活動。',
          '全港市民只要在12月16日當日開啟MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可在MyLink上載一張行山香港照片。',
          '大會將會精選150張最精彩的相片，並由公眾投票，獲得最多票數的頭100位參賽者將有機會獲智能手機一部！'
        ],
        submit: '參與活動'
      },
      reward: {
        title: '閣下完成【萬步有禮】活動，獲得獎品如下：',
        submit: '詳情'
      },
      photoInfo: '閣下參與「萬步有禮」攝影活動的資料如下：',
      noData: '沒有紀錄'
    },
    photoUploadHome: {
      title: '「萬步有禮」活動',
      rulesText: '本人同意【萬步有禮】',
      rulesLinkText: '活動條款及細則',
      rulesText1: '',
      submit: '開始',
      adImg: 'static/xingshan/wanbu-tc.jpg'
    },
    photoUpload: {
      title: '「萬步有禮」活動',
      addFile: '上載照片',
      name: '相片標題',
      namePlaceholder: '相片標題',
      userNamePlaceholder: '輸入姓名',
      submit: '上傳',
      loading: '上傳中...',
      tip: {
        yes: '確定',
        notice: '注意',
        photoName: '中文上限10個字，英文上限20個字',
        userName: '須與香港身分證上姓名相同',
        error: '系統繁忙，請稍後再試'
      }
    },
    photoUploadResult: {
      title: '「萬步有禮」活動',
      successTip: '圖片上傳成功！',
      successInfo: '入圍作品將在2018年12月24日公佈結果，敬請留意！',
      upLoadLabel: '上傳：',
      nameLabel: '姓名：',
      phoneLabel: '手機號碼：',
      titleLabel: '相片標題：',
      return: '返回首页'
    },
    photoRules: {
      title: '條款及細則',
      organizer: {
        title: '主辦機構',
        list: [
          '「中移動香港行山節—萬步有禮」活動由中國移動香港有限公司（「中國移動香港」或「主辦機構」）主辦。',
          '參加者一旦參與活動，即代表瞭解、同意並願意遵守本文所載的條款及細則，如有違反條款、以不誠實手法進行此活動及、或造假者，中國移動香港有權取消其參加及得獎資格，而不作任何通知。'
        ]
      },
      bili: {
        title: '參加資格',
        list: [
          '所有的公眾人士於香港時間2018年12月16日00:00至當日23:59步行達10,000步或以上，即可參加本活動。10,000步只以MyLink手機應用程式內計步功能計算為準，其他任何計步器紀錄恕不接受。參加者如未滿十八歲，必須先獲家長/監護人簽署同意書方可參加。主辦機構有權要求參加者出示年齡證明及（如有需要）該等同意書證明。',
          '參加者必須於Google Play 或 App Store 下載MyLink手機應用程式（「MyLink」）。中國移動香港客户（包括現有的儲值卡客户、服務計劃客户及用身份證登記的企業客户）需以電話號碼及客户密碼登入MyLink; MySim客户及非中國移動客户需於活動專頁輸入電話及驗證碼登入MyLink。所有參加者必須同意本活動條款及細則，才可參加本活動。',
          '參加者必須提供支援短信功能的香港手機號碼以獲得一次性驗證碼進行身份驗證。如登記的手機號碼不支援短信功能或不能使用、無效或在領取禮品時已經更改，該得獎資格會被取消。',
          '參加者必須於活動期間登入MyLink，並在計步期間一直開啟MyLink及維持流動數據功能，活動期間累計步數將由香港時間12月16日00:00開始截至12月16日23:59 (香港時間)為止。',
          '活動只限香港註冊的流動電話號碼用户參與，每個香港流動電話號碼只限參加一次。如發現參加者以外掛程式或其他非正式途徑如空號或假帳户或其他影響公平性​​的方式參加本活動，中國移動香港將取消該參加者的資格而不作另行通知。',
          '中國移動香港保留對參加者資格的最終決定權。'
        ]
      },
      time: {
        title: '活動日期',
        list: ['活動日期於香港時間2018年12月16日00:00至當日23:59期間進行。提交相片時間以中國移動香港伺服器所收到作品之時間作準，逾時提交作品將不獲受理。']
      },
      notice: {
        title: '參加須知',
        list: [
          '參加者須清楚明白本活動內容及性質，並知道本活動需要消耗體力，同時確定健康情況適宜參與本活動。主辦單位建議所有參加者於活動期間自行留意個人的身體狀況是否良好及是否適合參與本活動。參加者於活動期間如有不適，請立即停止活動，並按需要向醫護人員求助。',
          '參加者參加本活動純屬自願性質及需自行承擔參加本活動之風險。任何參加者因參加本活動而引致之任何損失、傷害、費用、索賠、訴訟（包括但不限於直接、間接及後果性損失），主辦單位概不負上任何法律責任或作出賠償。',
          '如主辦單位懷疑參加者有 （i）進行或與異常/可疑活動有關、（ii）使用不當的方法或欺詐行為而使本活動任何部份運作中斷或受到幹擾，導致技術問題，或檢測到（iii）任何不誠實的行為、提供虛假或不正確的資料或（iv）任何違反本條款及細則或其他任何適用法律或條文；主辦單位擁有酌情權及最終決定權在不作任何通知及毋須對任何人士負上任何責任的情況下自行決定取消其參加及/或得獎資格，並對該人士保留追究權利。',
          '參加者於登記參加本活動時所提供的資料均不能更改。如登記頁面上所提供的資料有任何錯漏、不實或不正確，該登記則被視為無效。如得獎者因提供了虛假、錯漏或不正確的資料而導致無法收到領獎通知或不能領取禮品，主辦單位毋須為此承擔任何責任。',
          '主辦單位保留隨時更改本活動內容、終止本活動、修訂此條款及細則的權利，而無需另行通知。'
        ]
      },
      pedometer: {
        title: '有關MyLink計步功能',
        list: [
          '參加者必須於活動期間開啟MyLink及維持流動數據才能累積步數，如因任何技術中斷或錯誤、網絡擠塞或其他任何原因而產生或引致任何遲延、遺失、錯誤或無法辨識的回應、登記或提交等情況，主辦單位概不負責。參加者明白及同意不會就MyLink的數據提出任何異議。',
          '參加者可在活動期間登入MyLink，檢視MyLink計步器的步數。',
          '參加者明白不同裝置的計步器或有差距，一切結果會以主辦單位的電腦系統所示的步數紀錄為準。iOS裝置會存取Apple內置傳感器的步數紀錄; 而Android裝置會存取內置計步器/加速度傳感器的步數紀錄，任何其他第三方之計步方式均不獲接受。',
          '計步功能只支援iOS版本9.0或以上及iPhone 5S或以上型號之手機，而Android手機則需內置計步感應器及系統為［4.4］或以上及之指定型號手機，並須視乎手機生產商對個別手機型號之設定為準。'
        ]
      },
      upload: {
        title: '有關上載相片活動',
        list: [
          '當參加者於活動期間步數達到10,000步時，可按指示上載相片並可獲得換領禮品的機會一次。',
          '參加者須拍攝一張最能代表香港的相片，連同自創標題上載至MyLink手機應用程式。',
          '參加者只可遞交一張作品，檔案大小限制為5MB，惟必須遞交原創並未經發佈的相片，並為作品之唯一版權持有人。遞交作品時需要同時輸入最多十個中文字（連同標點符號）或最多二十個英文字母（連同空格及標點符號）的標題，但毋須遞交作品描述。參加者只得一次機會上載相片，提交後不得更改。如系統發現有參加者重複提交相片，將會被取消資格。',
          '參加作品須為數碼檔案，不限定使用數碼相機所攝之相片，亦接受負片、幻燈片、沖印相片之數位掃描檔案。',
          '主辦機構接受環景相片、黑白相片、高動態範圍（HDR）影像或以魚眼鏡頭拍攝的相片。參加者僅能對相片進行少量色彩加深（burning）、色彩加亮（dodging）或色彩校正（color correction）修改，適度裁切、黑白處理亦可接受。上述未提及之相片修改方式，一律禁止。若經查覺，該相片將喪失參加資格。',
          '主辦機構不接受含有任何浮水印的參加作品。',
          '主辦機構建議參加者保留未經軟件後製（如效果、濾鏡）或其他任何影像處理軟體後製過的原始數碼檔案。主辦機構審理有後製爭議的作品時，或會要求參加者提供原始檔案，如參加者無法提供，會被取消資格。',
          '主辦機構將選出150張相片供公眾投票。中國移動香港將以參加作品的美感、創意及原創性作為評審準則。如活動接獲少於150張相片，主辦機構篩走不合適相片後，其餘所有相片將交予公眾投票。150張相片在MyLink手機應用程式顯示的先後次序將根據上載時間而定，依據中國移動香港伺服器紀錄，較先上載的相片會獲較前顯示位置。',
          '公眾投票將於MyLink手機應用程式進行，投票者須為MyLink已登入的用户。投票日期為香港時間2018年12月24日00:00至12月30日23:59。每位投票者只有一次投票機會可投選一張至五張相片，但只可投選同一張相片一次。各張相片所獲票數將會實時顯示。',
          '如發現有相片票數有可疑情況，包括但不限於以外掛程式或其他非正式途徑如空號或假帳户或其他影響公平性​​的方式進行投票，中國移動香港將取消該參加者的資格而不作另行通知。中國移動香港對可疑情況的闡述及決定有最終決定權。',
          '參加者一經參與活動，即表示同意中國移動香港有永久免版權費及非獨家使用權將相片用於中國移動香港的：(i)印刷刊物 (ii)網上刊物及 (iii)其他宣傳媒體活動。作品一經提交於本活動完結後將不會發還予參加者。',
          '任何因電腦或電子裝置故障、網絡等技術問題而引致參加者未能準時提交參加作品，或有遺失、錯誤、無法辨識等情況，中國移動香港不會承擔任何責任。經網絡的送遞證明亦不可視作成功傳送參加作品的證明。',
          '主辦機構保留對任何參加作品，不接受或不公開的權利，包括但不限於，有關於誹謗、詆毀、淫穢、色情、辱罵、攻擊、褻瀆的內容或者侵犯任何版權或任何人的其他權利的內容。如果參加作品勝出後確認相片不適合，主辦機構保留撤銷獲獎的權利。',
          '參加者須保證上載作品不涉及粗言穢語及任何渲染色情暴力的內容，或侵犯或違反任何版權或商標或知識產權。中國移動香港保留刪除相關內容及取消任何違反以上條款之參加者的參加/得獎資格及採取法律追究行動之權利，並不會就有關侵權行為負上任何責任。'
        ]
      },
      prize: {
        title: '獎項及獎品',
        list1: [
          '於活動期間完成10000步，即可獲贈最多兩份禮品，所有禮品均受其使用條款及細則約束。「$10電子繳費券2張」只適用於中國移動香港的服務計劃客户；「$10電子增值券2張」只適用於中國移動香港的儲值卡客户；「中銀集團保險禮品包」適用於中國移動香港客户、MySim客户或非中國移動香港的客户。詳情如下：'
        ],
        thead1: {
          label: '禮品',
          value: '合資格參加者'
        },
        table1: [
          {
            label: '$10電子繳費券2張',
            value: '中國移動香港的服務計劃客户'
          },
          {
            label: '$10電子增值券2張',
            value: '中國移動香港的儲值卡客户'
          },
          {
            label: '中銀集團保險禮品包',
            value: '中國移動香港客户、MySim客户或非中國移動香港的客户'
          }
        ],
        list2: [
          '本活動所有的禮品視乎供應情況而定，換完即止。',
          '除特別註明外，本活動的禮品不可與其他優惠同時享用。',
          '本活動所有的禮品均不可退換或兑換現金，亦不能更換丶退款丶轉讓或轉售。',
          '於投票時段內，獲得最高票數的100名參加者將有機會獲得指定智能手機一部；餘下50名參加者將有機會獲得指定背囊一個，詳見下表：'
        ],
        thead2: {
          label: '票數排名',
          value: '獎品'
        },
        table2: [
          {
            label: '票數排名第一至第五名',
            value: 'iPhone XS (256GB)'
          },
          {
            label: '票數排名第六至第十名',
            value: 'Samsung Galaxy S9+ (256GB)'
          },
          {
            label: '票數排名第十一至第二十五名',
            value: 'iPhone 8 (256GB)'
          },
          {
            label: '票數排名第二十六至第三十名',
            value: 'HUAWEI Mate 20 Pro'
          },
          {
            label: '票數排名第三十一至第五十五名',
            value: 'HUAWEI P20'
          },
          {
            label: '票數排名第五十六至第八十名',
            value: 'Samsung Galaxy A8+'
          },
          {
            label: '票數排名第八十一至第一百名',
            value: 'iPhone SE (128GB)'
          },
          {
            label: '票數排名第一百零一名至第一百五十名',
            value: '「中移動香港行山節」指定背囊'
          },
        ],
        list3: [
          '如有相片於投票時段結束後獲得相同票數，依據中國移動香港伺服器紀錄，較先上載的相片會獲較高排名。',
          '中國移動香港送出之獎品均不可兑換現金或其他貨品/服務，亦不能更換、退款、轉讓及轉售。',
          '18歲以上的得獎者須親身或以書面形式授權另一名成年人領取獎品。18歲以下的得獎者必須由家長或監護人代為領獎，並須於領獎時提供家長/監護人同意書證明。',
          '獎品一經領取後，若有破壞、遺失或被竊，中國移動香港恕不補發。'
        ]
      },
      results: {
        title: '結果公佈',
        list: [
          '所有獎項的得獎名單將於MyLink手機應用程式內公佈。得獎名單將會公開的資料包括參加者姓名、相片、相片標題及參加者的首四位流動電話號碼。得獎者將獲專人以電話方式通知。中國移動香港將根據參加者登入MyLink手機應用程式的手機號碼聯絡得獎者。各獎項公佈日期如下：',
          '投票結果公佈日期及途徑：香港時間2019年1月7日中午12時在MyLink手機應用程式內公佈',
          '如中國移動香港於香港時間2019年1月18日23:59之前仍無法聯絡得獎者，或得獎者或其授權人或其家長 /監護人於香港時間2019年2月1日23:59之前仍沒有領取獎品，將被視作放棄論，其得獎資格將被取消。',
          '中國移動香港對供應商提供的商品或服務之品質、安全性及合法性，刊登內容之真實性及準確性，供應商的商譽與可信性均無控制力及保證。'
        ]
      },
      personal: {
        title: '個人資料收集聲明',
        list: [
          '主辦機構將會在參加者上載相片參加「萬步有禮」活動時，收集參加者的個人資料，包括手提電話號碼、年齡及姓名等。主辦機構保障參加者所提供之一切資料。當參加者使用服務上載相片時，有關個人資料將會被收集、儲存及使用以作核實。',
          '本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知您作為參加者收集資料的目的、您同意大會如何使用這些資料及您的權利。本聲明會不時更改，故請定期查閲。參加者每次登記及/ 或使用我們的服務時，即表示同意接受當時生效之個人資料收集聲明。',
          '參加者可能會被要求向主辦機構提供個人識別資料。為讓參加者可以參加「中移動香港行山節—萬步有禮」，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得參賽資格。'
        ]
      },
      purpose: {
        title: '資料之目的及用途',
        list: {
          title: '大會所收集之資料將用作以下用途：',
          list: [
            '識別和核實參加活動的參加者的身份及/ 或資格',
            '就有關或因參加活動的事項與參加者溝通',
            '匯編參加者的整體統計資料，分析、評估及改進主辦機構所提供的活動'
          ]
        }
      },
      transfer: {
        title: '資料之轉移',
        list: [
          '參加者之個人資料將被保密。然而由於系統管理、運作及保養需要，主辦機構會將有關資料轉移或披露予對主辦機構有保密責任並提供與主辦機構運作有關行政、電訊、電腦系統服務、數據處理或其他服務的承辦商。',
          '參加者有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閲或更正參加者之個人資料。如有任何查閲或更正資料的要求，請向本公司資料保障主任提出，其辦事處位於香港新界葵涌葵昌路51號九龍貿易中心1座20樓。主辦機構的私隱政策聲明可於其網頁www.hk.chinamobile.com獲取。',
          '參加者對於是次活動及評審的決定均不得異議。活動不設上訴機制。中國移動香港擁有修改及解釋以上規則的權利。如有任何爭議，中國移動香港保留最終決定權。',
          '本條款及細則受香港法律管轄。參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
          '本條款與細則的中、英文本如有任何歧義，概以英文本為準。'
        ]
      }
    },
    couponList: {
      title: '中銀集團保險禮品包',
      list: {
        travel: {
          img: 'static/xingshan/travel.jpg',
          title: '環宇遨翔旅遊保障計劃單次旅程68折/ 全年計劃8折',
          time: '2018年12月16日至2019年2月10日(包括首尾兩天)。',
          code: 'CMHKHF',
          url: 'https://www5.bocgins.com/untrv/index.html?url=html/home/home.html&channel=BOCGI&product=1002&lang=TW'
        },
        home: {
          img: 'static/xingshan/home.jpg',
          title: '周全家居綜合險8折',
          time: '2018年12月16日至2019年2月10日(包括首尾兩天)。',
          code: 'CMHKHF',
          url: 'https://www4.bocgins.com/zh-tw/website/online-apply-select/Home_Comprehensive/'
        },
        insurance: {
          img: 'static/xingshan/car.jpg',
          title: '汽車保險 - 私家車尊享特惠保費',
          time: '2018年12月16日至2019年2月10日(包括首尾兩天)。',
          code: 'CMHKHF',
          url: 'https://www4.bocgins.com/zh-tw/website/online-apply-select/Motor/'
        },
      }
    },
    coupon: {
      title: '詳情',
      use: '去使用',
      codeTitle: '優惠碼',
      copyTip1: '點擊優惠碼區域可複製優惠碼',
      copyTip2: '優惠碼已複製，可以在優惠頁面按貼上使用',
      copyTip3: '系統不支持複製優惠碼，可長按粘貼使用',
      confirm: '確定',
      tips: '閣下將跳轉至中銀集團保險有限公司網站',
      activity: {
        img: 'static/xingshan/zhongyin_logo.png',
        title: '中銀集團保險「保險計劃優惠包」優惠碼',
        explain: [
          {
            title: '推廣條款及細則:',
            list: [
              '此推廣不可與其他優惠同時使用(包括但不限於使用優惠編碼)。',
              '此推廣不能兌換現金或同等價值之物品。',
            ]
          },
          {
            title: '一般条款及细则：',
            list: ['本計劃由中銀集團保險有限公司 (「中銀集團保險」)承保。',
              '中銀集團保險已獲保險業監管局授權在中華人民共和國香港特別行政區經營一般保險業務，並受其監管。',
              '中銀集團保險保留根據投保人及/或受保人於投保時所提供的資料，而決定是否接受任何有關本計劃投保申請的絕對權利。',
              '中銀集團保險保留隨時修訂、暫停或取消本計劃、服務與優惠以及修訂有關條款的酌情權而毋須事先通知。',
              '本計劃各項條款及細則以中銀集團保險繕發的正式保單為準。各項保障項目及承保範圍、條款及不承保事項，請參閱保單。',
              '本宣傳品僅供參考，宣傳品只在香港派發，不能詮釋為在香港境外提供或出售或遊說購買中銀集團保險的任何產品的要約、招攬及建議。',
              '如本宣傳品的中、英文版本有任何歧異，概以英文版本為準。',
              '詳情請於辦公時間致電中銀集團保險客戶查詢熱線：(852) 3187 5100。']
          },
          {
            title: '中國移動香港條款與細則：',
            list: [
              '本活動所有優惠/禮品圖片及描述僅供參考，均以實物為準。',
              '任何因電腦、網路等技術問題而引致客戶所遞交的資料有遲延、遺失、錯誤、無法辨識等情況，中國移動香港概不負責。',
              '任何因合資格客戶參加本活動而引致之任何損失、傷害、費用、索賠、訴訟 (包括但不限於直接、間接及後果性損失)，中國移動香港概不負責。',
              '此優惠所涉及之產品、服務及資訊均由中銀集團保險有限公司（「供應商」）直接提供給合資格用戶，所有有關責任及義務由全權負責。',
              '中國移動香港對供應商於此優惠提供的商品或服務之品質、安全性及合法性，刊登內容之真實性及準確性，供應商的商譽與可信性，供應商實際出售商品或服務之能力均無控制力及保證。',
              '凡領取此優惠的用戶，即表示已細閱並同意此條款及細則及個別優惠的條款及細則。如有任何違反此等條款及細則、以不誠實手法參加或進行本活動及/或造假者，中國移動香港有權立即取消其享用此優惠的資格，而不作任何通知，並對任何違反行為保留追究權利。',
              '合資格客戶在本活動中所提供的個人資料，如姓名、手提電話號碼及電郵地址等，只會用作本活動聯絡客戶及領獎時核實身份的用途。中國移動香港會將有關個人資料保存及保密處理，並於領獎完結後2個月內銷毀。中國移動香港不會使用有關個人資料作為日後直接促銷的用途。如客戶欲查閱個人資料及更正個人資料或詢問個人資料有關聲明，請致函: 中國移動香港有限公司，地址：香港新界葵涌葵昌路51號九龍貿易中心1座20樓，收信人：資料保護主任或致電中國移動香港拒收商業電子訊息登記熱線62264926或客戶服務熱線2945 8888。',
              '如中國移動香港懷疑合資格客戶有 （i）進行或與異常/可疑活動有關、（ii）使用不當的方法或欺詐行為而使本活動任何部份運作中斷或受到干擾，導致技術問題，或檢測到（iii）任何不誠實的行為、提供虛假或不正確的資料或（iv）任何違反本條款及細則或其他任何適用法律或條文；中國移動香港有權在不作任何通知及毋須對任何人士負上任何責任的情況下自行決定取消其資格，並對該人士保留追究權利。',
              '若因延誤或未有履行本條款及細則或當中任何部分，且原因在中國移動香港合理控制範圍之外，或並非因為中國移動香港的過失或疏忽所致，而是因為戰爭、有即將發生戰爭之威脅、暴動、民衆騷動、叛亂、天災、政府或其他超國家法律機關實施限制、其他勞資糾紛、火災、爆炸、暴風雨、水災、雷擊、地震和其他自然災害等等所致，中國移動香港即不必對由此引起的任何損失和損害負責。',
              '除各供應商外，其他人士均無權根據《合約（第三者權利）條例》（香港法例第623 章）及適用於中國移動香港的其他規章强制執行本條款及細則，也無權享有本協議及適用於中國移動香港的其他規章所給予的任何利益。',
              '本條款及細則受香港法律管轄。合資格用戶同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
              '中國移動香港或中銀集團保險有限公司隨時更改本優惠內容、終止此優惠、修訂此條款及細則的權利，而恕不另行通知。'
            ]
          },
        ]
      }
    },
    photoPedding: {
      photoDetail: {
        title: '「萬步有禮」活動',
        h1: '「萬步有禮」活動',
        time: [['2018.12.24 ', '入圍作品公布'], ['2018.12.24-30', '作品公眾投票'], ['2019.1.7(中午12:00)', '投票結果公布']],
        p: ['大會鼓勵全民運動，特意舉辦「萬步有禮」活動。',
          '全港市民只要在12月16日當日開啟MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可在MyLink上載一張行山香港照片。',
          '大會將會精選150張最精彩的相片，並由公眾投票，獲得最多票數的頭100位參賽者將有機會獲智能手機一部！'],
        btn: '敬請留意入圍作品結果！',
        agency:['電話：2127 4720 (星期一至五早上10時至晚上7時)','電郵：wewalk.enquiry@gmail.com']
      },
      nullPhoto: {
        title: '查詢結果',
        sorry: '抱歉！',
        tips: '未查詢到閣下參與活動的紀錄'
      },
      photo: {
        title: '查詢結果',
        h1: '閣下參與「萬步有禮」攝影活動的資料如下：',
        name: '姓名：',
        phone: '手機號碼：',
        tips: '活動相片正在評審中，密切留意！'
      }
    },
    photoVote:{
      title1:'萬步有禮 送出100部智能手機',
      title2:'活動投票',
      title3:'投票结果',
      btn1:'去查看',
      btn2:'返回活動頁',
      btn3:'提交',
      btn4:'否',
      btn6:'是',
      btn5:'參與投票',
      votePhoto:'入圍作品',
      noData:'无数据',
      share:{
        index:['「萬步有禮」相片投票','投票結果'],
        myPhoto:['「萬步有禮」相片投票','我正在投選「萬步有禮」最能代表香港的相片，入圍作品編號','快来帮我投票吧'],
        list:['活動投票','「萬步有禮」相片投票']
      },
      end:['「萬步有禮」活動投票階段已經結束，結果將於','2019年1月7日','公布，敬請關注！'],
      voted:{
        title:['感謝閣下投票！','多謝你的支持！'],
        label:['投票作品:','閣下投票資料為：'],
        item:['編號:','票數:']
      },
      nuPicked:['閣下參與「萬步有禮」攝影活動的資料如下：','抱歉！閣下的相片未能入圍。','150張入圍相片投票階段已經展開，立即投選你的心水相片！'],
      picked:['阁下参与摄影大赛活动信息如下：','閣下的作品已獲選為150張最精彩的相片，投票階段已經展開，有機會贏取智能手機一部！立即投選你的心水相片！','入圍作品編號:'],
      voteError:['閣下投票失敗！','請稍候再試'],
      voteList:{
        inputplaceholder:'請輸入相片編號',
        vote:['投票','已投','票','可投'],
        tips:['提示','閣下可選投5票，還可繼續選擇。一經提交後，不能再參與投票。是否繼續提交？'],
        rules:[{
          title:'萬步有禮 送出100部智能手機',
          list:['大會鼓勵全民運動，特意舉辦「10000步有禮」攝影比賽。',['全港市民只要在','12月16日','當日開啟中國移動香港MyLink手機應用程式，透過內建的WeWalk頁面計步功能並步行夠一萬步，即可在MyLink上載一張行山照片。 '],'大會將精選150張最精彩的相片，並由公眾投票，獲得最多票數的頭100位參賽者將可獲智能手機一部！']
        },{
          title:'活動投票規則',
          label:['投票時間：',' 12月24日00:00 - 12月30日23:59'],
          list:['限MyLink登陸用戶投票，每位用戶對每張照片限投票1次。','每位MyLink登錄用戶最多可投票5張評選圖片。']
        }]
      }
    },
    photoResult:{
      title1:'「萬步有禮」活動',
      title2:'結果公佈',
      title3:'下載獲獎相片',
      btn1:'結果公佈',
      normal:['萬步有禮 送出100部智能手機'],
      sorry:'抱歉，閣下未中獎，謝謝關注本次行山節活動，歡迎下次參與！',
      win:['恭喜您！閣下可於2019年1月11日（星期五）起至2月1日或之前親自或委託他人到大會秘書處領獎。詳情請聯絡秘書處。',
        '電話：(852) 2127 4720',
        '電郵：wewalk.enquiry@gmail.com',
        '地址：新界葵涌葵昌路50號葵昌中心6樓12室'
      ],
      listTitle:'獲獎結果',
      prize:['第','名'],
      share:{
        title:'「萬步有禮」活動結果公布！',
        content:'中移動香港行山節「萬步有禮」活動'
      },
      end:'留意萬步有禮得獎結果',
      save:'長按相片可儲存相片到相冊'
    }
  },
  ...newYear,
  ...activity
}



// WEBPACK FOOTER //
// ./src/locale/zh-hk.js